import React from 'react';
import loadinglogo from '@/../../public/logo2.png';

export default function LoadingPage() {
    return (
        <div className='absolute w-full h-full z-[9000] bg-gradient-to-bl from-white to-white animate-gradientMove  top-0 right-0 flex justify-center items-center'>
            <div className='relative w-60 h-60 flex justify-center items-center p-5'>

                {/* Spinning Gradient Background */}
                <div className='absolute size-72 rounded-full animate-spin border-custom-dark-blue border-t-2 border-b-2 '></div>

                {/* Image */}
                <img src={loadinglogo} className='relative h-52 ' alt='Loading Logo' />
            </div>
            <style>
                {`
                @keyframes gradientMove {
                    0% { background-position: 100% 0; }
                    100% { background-position: 0 0; }
                }
                .animate-gradientMove {
                    animation: gradientMove 3s linear infinite;
                    background-size: 300% 300%;
                }
                `}
            </style>
        </div>
    );
}

